import LegalLayout from "../components/LegalLayout";

const TermsPage = () => (
  <LegalLayout title="Terms of Service">
    <section className="space-y-3">
      <h2 className="text-xl font-semibold text-foreground">Agreement</h2>
      <p>
        By using apitomcpconverter.com, you agree to these Terms of Service. If you do not agree, do
        not use the service.
      </p>
    </section>

    <section className="space-y-3">
      <h2 className="text-xl font-semibold text-foreground">Service</h2>
      <p>
        We provide tools to convert API specifications into MCP servers and related hosting or
        registry features. We may change, suspend, or discontinue any part of the service at any
        time.
      </p>
    </section>

    <section className="space-y-3">
      <h2 className="text-xl font-semibold text-foreground">Your responsibilities</h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>You are responsible for the API specifications and content you submit.</li>
        <li>You must have the rights needed to use, convert, and host the APIs you provide.</li>
        <li>You must not misuse the service, attempt unauthorized access, or disrupt other users.</li>
        <li>You must comply with applicable laws and third-party API terms.</li>
      </ul>
    </section>

    <section className="space-y-3">
      <h2 className="text-xl font-semibold text-foreground">Accounts</h2>
      <p>
        You are responsible for activity under your account and for keeping your sign-in credentials
        secure. We may suspend or terminate access that violates these terms or creates risk for the
        service or other users.
      </p>
    </section>

    <section className="space-y-3">
      <h2 className="text-xl font-semibold text-foreground">Disclaimers and liability</h2>
      <p>
        The service is provided on an as-is and as-available basis without warranties of any kind.
        To the fullest extent permitted by law, apitomcpconverter.com and its operators are not
        liable for indirect, incidental, special, consequential, or punitive damages, or for loss of
        data, profits, or business arising from your use of the service.
      </p>
    </section>

    <section className="space-y-3">
      <h2 className="text-xl font-semibold text-foreground">Changes</h2>
      <p>
        We may update these terms from time to time. Continued use of the service after changes
        become effective means you accept the updated terms.
      </p>
    </section>
  </LegalLayout>
);

export default TermsPage;
